import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user/user.js";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

let key = "vetvise";
import env from "../env";

if (env === "dev") key = key + "_dev";
if (env === "staging") key = key + "_staging";
if (env === "preview") key = key + "_preview";

const vuexLocalStorage = new VuexPersist({
  key: key,
  storage: window.localStorage,
});

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    user
  },
  plugins: [vuexLocalStorage.plugin]
});

export default store;